import { IStore } from 'Store/.';
import { createSelector } from 'reselect';

const getIsFetchingAbout = (state: IStore) => state.infoAbout.isFetching;
const getIsFetchAboutFailed = (state: IStore) => state.infoAbout.isFetchFailed;
const getAboutContent = (state: IStore) => state.infoAbout.content;

export {
  getIsFetchingAbout,
  getIsFetchAboutFailed,
  getAboutContent,
};


// WEBPACK FOOTER //
// ./src/components/InfoAbout/Redux/selectors.tsx